'use client';
import { Great_Vibes } from 'next/font/google';
import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';

const greatVibes = Great_Vibes({
  subsets: ['latin'],
  weight: '400',
});

const name = 'akif';

export default function SignatureAkif() {
  const [key, setKey] = useState(0); // for looping

  useEffect(() => {
    const timer = setInterval(
      () => {
        setKey((prev) => prev + 1); // remount to restart animation
      },
      3000 + name.length * 300
    ); // wait 3s + total animation time
    return () => clearInterval(timer);
  }, []);

  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.3, // slower animation between letters
      },
    },
  };

  const letter = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }, // slower fade + move
  };

  return (
    <div
      className={`inline-block px-4 py-2 rounded-xl text-white ${greatVibes.className}`}
      style={{
        background: 'linear-gradient(135deg, #6C63FF, #00D4FF)',
        fontSize: '2rem',
        letterSpacing: '-0.01em',
        lineHeight: 1,
      }}
    >
      <motion.div
        key={key}
        className="inline-flex"
        variants={container}
        initial="hidden"
        animate="visible"
      >
        {name.split('').map((char, index) => (
          <motion.span key={index} variants={letter}>
            {char}
          </motion.span>
        ))}
      </motion.div>
    </div>
  );
}
